import { BalancoFinanceiroOperacaoCategoriaItemConta } from "features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import moment from "moment";
import { mapFormaPagamentoToLabel } from "infra/helpers/mapFormaPagamentoToLabel";

function useRelatorioBalancoFinanceiroPdfColumns(categoria?: {
  breadcrumb: string;
  nome: string;
}): PDFTableColumn<BalancoFinanceiroOperacaoCategoriaItemConta>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<BalancoFinanceiroOperacaoCategoriaItemConta>[] =
      [];

    columns.push({
      title: "Descrição",
      flexGrow: 2.4,
      render: (original) => (
        <View>
          <Text>
            {categoria ? (
              <>
                <Text style={{ fontWeight: "medium" }}>
                  {categoria?.breadcrumb} {categoria?.nome}
                </Text>{" "}
                -
              </>
            ) : null}{" "}
            {original.descricao}
          </Text>
        </View>
      ),
    });

    columns.push({
      title: "Competência",
      flexGrow: 1,
      textAlign: "center",
      render: (original) => (
        <View>
          <Text>
            {original.competencia
              ? moment(original.competencia, "YYYY-MM").format("DD/MM/YYYY")
              : "--"}
          </Text>
        </View>
      ),
    });

    columns.push({
      title: "Liquidação",
      flexGrow: 0.9,
      textAlign: "center",
      render: (original) => (
        <View>
          <Text>
            {original.dataLiquidacao
              ? moment(original.dataLiquidacao).format("DD/MM/YYYY")
              : "--"}
          </Text>
        </View>
      ),
    });

    columns.push({
      title: "Forma de Pagamento",
      flexGrow: 1.5,
      textAlign: "center",
      render: (original) => (
        <View>
          <Text>
            {original.formaPagamentoId
              ? mapFormaPagamentoToLabel(original.formaPagamentoId)
              : "--"}
          </Text>
        </View>
      ),
    });

    columns.push({
      title: "Nota Fiscal",
      flexGrow: 0.6,
      textAlign: "center",
      render: (original) => (
        <View>
          <Text>{original.notaFiscal ?? "--"}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Valor",
      flexGrow: 1,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.valorReferenteComposicao)}</Text>
        </View>
      ),
    });
    return columns;
  }, [categoria]);
}

export default useRelatorioBalancoFinanceiroPdfColumns;
